<template>
  <div class="privatesms">
    <transition name=".el-zoom-in-center" style="margin-bottom: 100px;">
    <div class="title_msg" v-if="show_list">
        <img src="../../assets/lives/goback.png" alt="" @click="excitprivatesms">
            私聊列表
        <div class="line_title">
        </div>
    </div>
    </transition>
    <transition name=".el-zoom-in-center" style="margin-bottom: 100px;">
    <div class="privatesms_list" v-show="show_list">
       <div @click="gotoitem(item.sendDetail)" v-for="(item,index) in msg_list" :key="index">
            <span class="dot_tips"></span>
            <img :src="JSON.parse(item.sendDetail[0].extra).headUrl || '/static/img/anchor.8a7fdcca.png'" alt="">
            <span v-if="JSON.parse(item.sendDetail[0].extra).role  == 2">主播</span>
            <span v-if="JSON.parse(item.sendDetail[0].extra).role  == 3">助理</span>
            <span>{{item.sendName}}</span>
            <span>{{formatDate(item.sendDetail[item.sendDetail.length -1].sendTime)}}</span>
       </div>
    </div>
    </transition>
    <transition name=".el-zoom-in-center" style="margin-bottom: 100px;">
    <div class="title_msg" v-show="!show_list">
        <img src="../../assets/lives/goback.png" alt="" @click="gobacklist">
            私聊中
        <div class="line_title">
        </div>
    </div>
    </transition>
    <transition name=".el-zoom-in-center" style="margin-bottom: 100px;">
    <div v-show="!show_list" style=" height:100%;">
        <div class="privatesmsing">
            <div class="item_privatesmsing" v-for="(item1,index1) in history_msgList">
                 <div>
                     <img :src="JSON.parse(item1.extra).headUrl || '/static/img/anchor.8a7fdcca.png'" alt="">
                     <span>主播</span>
                     <span>{{item1.sendName}}</span>
                 </div>
                 <div v-html="show_express(item1.text)"></div>
            </div>
         </div>
         <div class="input_msg">
            <div><input type="text" placeholder="请输入回复内容"></div>
            <div class="btn_msg">发送</div>
         </div>
    </div>
    </transition>
  </div>
</template>

<script>
import message from './message.vue'
import { mapState } from 'vuex'
import face from '@/utils/face';
export default {
  name: 'commodity',
  props: {
    
  },
  computed:{
    ...mapState({
        privatesmsList:(state)=>state.privatesmsList
    })
  },
  watch:{
    privatesmsList:{
        handler(val){
            this.msg_list = JSON.parse(JSON.stringify(this.privatesmsList))
            var premessage_view = document.querySelector('.privatesmsing')
            setTimeout(() => {
                premessage_view.scrollTo(0,premessage_view.scrollHeight)
            }, 100);
            console.log(premessage_view.scrollHeight);
        }
    }
  },
  data() {
    return {
        show_list:true,
        msg_list:[],
        history_msgList:[],
    }
  },
  created() {
    // message.methods.logoutlive()
  },
  methods: {
    excitprivatesms(){
        this.$emit("excitprivatesms",false)
    },
    show_express(v){
      return face.replaceEm(v)
    },
    gobacklist(){
            this.show_list=true
        },
    gotoitem(val){
        this.show_list=false
        this.history_msgList = val
    },

    formatDate(date) {
        return new Date(date).toLocaleString()
    } 
  },
 
}
</script>
<style scoped>
.privatesms{
    position: relative;
    width: 100%;
    height: 100%;
    background: #FAFAFA;
    border-radius: 10px;
}
.title_msg{
    position: relative;
    padding-top: 18px;
    height: 6%;
    font-size: 16px;
    color: #256EE7;
    font-weight: 550;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);
}
.title_msg img{
    position: absolute;
    left: 28px;
    width: 20px;
    height: 22px;
}
.line_title{
    width: 32px;
    height: 3px;
    margin: 4px auto;
    background-color: #256EE7;
    border-radius: 2px;
}
.privatesms_list{
    height: 87%;
    padding: 24px;
    overflow-y: scroll;
    padding: 8px 20px;
}
.privatesms_list::-webkit-scrollbar {
    width: 0px;
}
.privatesms_list>div{
    width: 100%;
    height: 58px;
    border-bottom: 1px solid #ECECEC;
}
.privatesms_list>div img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    float: left;
    line-height: 58px;
    vertical-align: middle;
    margin-top: 16px;
    margin-right: 12px;

}
.privatesms_list>div span:nth-child(3){
    float: left;
    width: 28px;
    height: 16px;
    background: linear-gradient(314deg, #377FF7 0%, #44B0FF 100%);
    border-radius: 2px;
    font-size: 10px;
    color: #fff;
    margin-top: 23px;
    margin-right: 8px;
}
.privatesms_list>div span:nth-child(4){
    float: left;
    font-size: 12px;
    color: #999999;
    margin-top: 22px;
}
.privatesms_list>div span:nth-child(5){
    float: right;
    font-size: 12px;
    color: #555555;
    margin-top: 26px;
}
.privatesmsing{
    padding: 10px 24px;
    height: 83%;
    overflow-y: scroll;
}
.privatesmsing::-webkit-scrollbar {
    width: 0px;
}
.item_privatesmsing{
    overflow: hidden;
    margin-top: 10px;
    text-align: left;
}
.item_privatesmsing>div:first-child{
    overflow: hidden;
}
.item_privatesmsing>div:first-child img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    float: left;
    line-height: 58px;
    margin-right: 12px;
}
.item_privatesmsing>div:first-child span:nth-child(2){
    width: 28px;
    height: 16px;
    background: linear-gradient(314deg, #377FF7 0%, #44B0FF 100%);
    border-radius: 2px;
    color: #fff;
    float: left;
    font-size: 10px;
    margin-right: 8px;
    line-height: 16px;
    text-align: center;
}
.item_privatesmsing>div:first-child span:nth-child(3){
    border-radius: 2px;
    float: left;
    color: #999999;
    font-size: 10px;
}
.item_privatesmsing>div:last-child{
    margin-bottom: 15px;
    float: left;
    margin-left: 42px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
    border-radius: 0px 5px 5px 5px;
    text-align: left;
    max-width: 75%;
    font-size: 13px;
    padding: 13px 16px;
    width: auto;
    word-break: break-all;
}
.item_privatesmsing1{
    overflow: hidden;
    margin-top: 10px;
    text-align: left;
}
.item_privatesmsing1>div:first-child{
    overflow: hidden;
}
.item_privatesmsing1>div:first-child img{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    float: right;
    line-height: 58px;
    margin-left: 12px;

}
.item_privatesmsing1>div:first-child span:nth-child(2){
    border-radius: 2px;
    float: right;
    color: #999999;
    font-size: 10px;
}
.item_privatesmsing1>div:last-child{
    float: right;
    width: 70%;
    margin-bottom: 15px;
    margin-right: 42px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
    border-radius: 5px 0px 5px 5px;
    text-align: left;
    /* margin-top: 8px; */
    font-size: 13px;
    padding: 13px 16px;
}
.dot_tips{
    padding: 4px;
    border-radius: 50%;
    background: red;
    float: left;
    margin-top: 10px;
}
.input_msg{
    color: #999;
    height: 5%;
    text-align: left;
}
.input_msg>div:first-child{
    float: left;
    height: 100%;
    width: 80%;
    background-color: #EEEEEE;
    border-radius: 5px;
    margin-top: 1%;
    margin-left: 2%;
 }
 .input_msg>.btn_msg{
    float: left;
    margin-top: 1%;
    width: 16%;
    padding: 2.2% 0;
    background-color: #256EE7;
    color: #fff;
    font-size: 15px;
    border-radius: 5px;
    text-align: center;
 }
 .input_msg>div>input{
    outline: none;
    border: 0;
    background-color: #EEEEEE;
    height: 100%;
    padding: 0 10px;
    width: 80%;
 }
</style>
